import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
// import 'primereact/resources/themes/saga-blue/theme.css';
// import 'primereact/resources/primereact.min.css';
// import 'primeicons/primeicons.css';

const RecentExpense = ({ expenseData, expenseDataLoading, expenseDataError }) => {
    const reportingFinancialExpense = useSelector((state) => state.reportingExpense);
    const [filteredData, setFilteredData] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);

    useEffect(() => {
        if (expenseData && reportingFinancialExpense) {
            const filtered = expenseData.filter(expense =>
                !expense.is_delete &&
                reportingFinancialExpense.expCategory && reportingFinancialExpense.expCategory.includes(expense.exp_category._id) &&
                reportingFinancialExpense.expYear && new Date(expense.exp_date).getFullYear() === reportingFinancialExpense.expYear &&
                reportingFinancialExpense.expCurrency && reportingFinancialExpense.expCurrency.includes(expense.exp_currency)
            ).map(expense => ({
                exp_id: expense.exp_id,
                exp_category_name: expense.exp_category.exp_category_name,
                client_name: expense.exp_client ? expense.exp_client.client_name || expense.exp_client.legal_entity_name : 'Non Billable',
                exp_date: expense.exp_date,
                exp_is_billable: expense.exp_is_billable ? 'Yes' : 'No',
                amount: expense.exp_amount,
                currency: expense.exp_currency,
                created_at: expense.created_at
            }));
            const sortedData = filtered.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
            setFilteredData(sortedData);
        }
    }, [expenseData, reportingFinancialExpense]);

    const onPageChange = (e) => {
        setCurrentPage(e.first / rowsPerPage);
    };

    const renderStatus = (rowData) => {
        const status = rowData.exp_is_billable;
        const statusClass = status === 'Yes' ? 'payment-status manual' : 'payment-status overdue';
        return <span className={`payment-status ${statusClass}`}>{status}</span>;
    };

    const renderDueDate = (rowData) => {
        const dueDate = new Date(rowData.exp_date);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return dueDate.toLocaleDateString(undefined, options);
    };

    const renderAmount = (rowData) => {
        var totalAmount = rowData.amount.toLocaleString("en-US", {
            style: "currency",
            currency: rowData.currency || 'USD',
        });

        return `${totalAmount}`;
    };

    if (expenseDataLoading) {
        return (
            <div className="datatable-team-maintb">
                <div className="p-datatable p-component p-datatable-responsive-scroll" style={{ marginBottom: 0, paddingBottom: 0 }}>
                    <div className="p-datatable-wrapper" style={{ paddingBottom: 0, marginBottom: 0 }}>
                        <table
                            className="p-datatable-table"
                            style={{ minWidth: "50rem", width: "100%", textAlign: "left", marginBottom: 0, borderSpacing: 0 }}
                        >
                            <thead className="p-datatable-thead">
                                <tr>
                                    <th style={{ width: "12%", paddingRight: "20px", textAlign: "left", paddingLeft: "22px", paddingTop: "11px", paddingBottom: "12px", background: "#F5F6F8", fontWeight: 500, fontSize: "17px", lineHeight: "21px", color: "#6A7988" }}>Expense Id</th>
                                    <th style={{ paddingRight: "20px", textAlign: "left", paddingTop: "11px", paddingBottom: "12px", background: "#F5F6F8", fontWeight: 500, fontSize: "17px", lineHeight: "21px", color: "#6A7988" }}>Category</th>
                                    <th style={{ width: "15%", paddingRight: "20px", textAlign: "left", paddingTop: "11px", paddingBottom: "12px", background: "#F5F6F8", fontWeight: 500, fontSize: "17px", lineHeight: "21px", color: "#6A7988" }}>Client</th>
                                    <th style={{ width: "15%", paddingRight: "20px", textAlign: "left", paddingTop: "11px", paddingBottom: "12px", background: "#F5F6F8", fontWeight: 500, fontSize: "17px", lineHeight: "21px", color: "#6A7988" }}>Date</th>
                                    <th style={{ paddingRight: "20px", textAlign: "left", paddingTop: "11px", paddingBottom: "12px", background: "#F5F6F8", fontWeight: 500, fontSize: "17px", lineHeight: "21px", color: "#6A7988" }}>Billable</th>
                                    <th style={{ paddingRight: "20px", textAlign: "left", paddingTop: "11px", paddingBottom: "12px", background: "#F5F6F8", fontWeight: 500, fontSize: "17px", lineHeight: "21px", color: "#6A7988" }}>Amount</th>
                                </tr>
                            </thead>
                            <tbody className="p-datatable-tbody" style={{ marginBottom: 0, paddingBottom: 0 }}>
                                {Array.from({ length: 5 }).map((_, index) => (
                                    <tr key={`skeleton-${index}`}>
                                        <td style={{ width: "12%", paddingRight: "20px", paddingLeft: "22px", paddingTop: "12px", paddingBottom: "12px", borderBottom: "1px solid #E5E7EB" }}>
                                            <div style={{ width: "80px", height: "20px", backgroundColor: "#e5e7eb", borderRadius: "4px", animation: "pulse 1.5s ease-in-out infinite" }} />
                                        </td>
                                        <td style={{ paddingRight: "20px", paddingTop: "12px", paddingBottom: "12px", borderBottom: "1px solid #E5E7EB" }}>
                                            <div style={{ width: "100px", height: "20px", backgroundColor: "#e5e7eb", borderRadius: "4px", animation: "pulse 1.5s ease-in-out infinite" }} />
                                        </td>
                                        <td style={{ width: "15%", paddingRight: "20px", paddingTop: "12px", paddingBottom: "12px", borderBottom: "1px solid #E5E7EB" }}>
                                            <div style={{ width: "120px", height: "20px", backgroundColor: "#e5e7eb", borderRadius: "4px", animation: "pulse 1.5s ease-in-out infinite" }} />
                                        </td>
                                        <td style={{ width: "15%", paddingRight: "20px", paddingTop: "12px", paddingBottom: "12px", borderBottom: "1px solid #E5E7EB" }}>
                                            <div style={{ width: "140px", height: "20px", backgroundColor: "#e5e7eb", borderRadius: "4px", animation: "pulse 1.5s ease-in-out infinite" }} />
                                        </td>
                                        <td style={{ paddingRight: "20px", paddingTop: "12px", paddingBottom: "12px", borderBottom: "1px solid #E5E7EB" }}>
                                            <div style={{ width: "60px", height: "24px", backgroundColor: "#e5e7eb", borderRadius: "12px", animation: "pulse 1.5s ease-in-out infinite" }} />
                                        </td>
                                        <td style={{ paddingRight: "20px", paddingTop: "12px", paddingBottom: "12px", borderBottom: "1px solid #E5E7EB" }}>
                                            <div style={{ width: "80px", height: "20px", backgroundColor: "#e5e7eb", borderRadius: "4px", animation: "pulse 1.5s ease-in-out infinite" }} />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <style>{`
                    @keyframes pulse {
                        0%, 100% {
                            opacity: 1;
                        }
                        50% {
                            opacity: 0.5;
                        }
                    }
                `}</style>
            </div>
        );
    }

    return (
        <div className="datatable-team-maintb">
            <DataTable
                value={filteredData.slice(0, 5)}
                tableStyle={{ minWidth: '50rem', width: '100%', textAlign: 'left' }}
                paginator={false}
                // paginator={filteredData.length > 10}
                paginatorClassName="recent-invoices-pagination"
                rows={rowsPerPage}
                // first={currentPage * rowsPerPage}
                // onPage={onPageChange}
                emptyMessage={
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "48px 24px", gap: "10px" }}>
                    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="6" y="10" width="32" height="26" rx="3" stroke="#D0D5DD" strokeWidth="2" />
                      <path d="M6 16h32" stroke="#D0D5DD" strokeWidth="2" />
                      <path d="M14 7v6M30 7v6" stroke="#D0D5DD" strokeWidth="2" strokeLinecap="round" />
                      <path d="M13 24h6M13 29h12" stroke="#BDBDBD" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                    <p style={{ margin: 0, fontSize: "15px", fontWeight: "500", color: "#282828" }}>No expenses found</p>
                    <p style={{ margin: 0, fontSize: "13px", color: "#96A8BA" }}>Try adjusting your filters.</p>
                  </div>
                }
            >
                <Column
                    field="exp_id"
                    header="Expense Id"
                    sortable
                    style={{ width: '12%', paddingRight: '20px' }}
                ></Column>
                <Column
                    field="exp_category_name"
                    header="Category"
                    sortable
                    style={{ paddingRight: '20px' }}
                ></Column>
                <Column
                    field="client_name"
                    header="Client"
                    sortable
                    style={{ width: '15%', paddingRight: '20px' }}
                ></Column>
                <Column
                    field="exp_date"
                    body={renderDueDate}
                    header="Date"
                    sortable
                    style={{ width: '15%', paddingRight: '20px' }}
                ></Column>
                <Column
                    field="exp_is_billable"
                    body={renderStatus}
                    header="Billable"
                    sortable
                    style={{ paddingRight: '20px' }}
                ></Column>
                <Column
                    field="amount"
                    body={renderAmount}
                    className="amount-expense-recent"
                    header="Amount"
                    sortable
                    style={{ paddingRight: '20px' }}
                ></Column>
            </DataTable>
        </div>
    );
};

export default RecentExpense;
